import { z } from "zod";
/**
 * A person's own profile (architecture §5, WP-029). The name is what other people see in chat,
 * mentions and member lists; it is read live from `users/{uid}`, so a rename shows everywhere.
 * The email is the Google sign-in identity and is not editable.
 */
export const ProfileName = z
    .string()
    .trim()
    .min(1, "Enter a name.")
    .max(80, "A name is at most 80 characters.")
    .refine((name) => !/[\r\n\u2028\u2029]/.test(name), "A name is one line.");
/** `people.updateProfile`: the caller's own profile only; there is no uid to name. */
export const PeopleUpdateProfileInput = z.object({ name: ProfileName });
export const PeopleUpdateProfileOutput = z.object({ name: z.string() });
//# sourceMappingURL=people.js.map